
import React, {  useRef } from "react";
import {
    Box,
    Button,
    Switch,
    TextField
  } from "@mui/material";

import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useDispatch } from "react-redux";
import {
  updatePlotHeight,
  updatePlotWidth,
  reset
} from "../../../redux/features/nodes";
import { setClickedFalse } from "../../../redux/features/popUp/popUp.slice";
import DimensionsToggle from "../../../common-components/DimensionsToggle";
import { defaultUnit } from "../../../redux/features/appState";

const PlotSizePopUp = () => {

  const dispatch = useDispatch();
  const firstInitialisation= useRef(true);
  const plotWidth = useSelector((state:any ) => state.nodesState.plotWidth);
  const plotHeight = useSelector((state: any) => state.nodesState.plotHeight);
  const handleHeightChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(updatePlotHeight(Number(event.target.value)));
    };

  const unit = useSelector(
    (state: RootState) => state.outputEditorButtonState.unit,
  );
  const handleWidthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(updatePlotWidth(Number(event.target.value)));
    };
    if(firstInitialisation.current){
      dispatch(defaultUnit())
      dispatch(reset());
      dispatch(updatePlotWidth(0));  
      dispatch(updatePlotHeight(0));
      firstInitialisation.current=false;
    }
  
  return (
    
    
      <Box
        sx={{
          width: "500px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          height:"280px",
          backgroundColor: "#FF9A56",
          position: "absolute",
          top: "30%",
          left: "35%",
          zIndex:"10",
          borderRadius:"20px",
          gap: "8px",
        }}
      >
        <Box
        sx={{
            height: "10px",
            display:"flex",
            fontFamily: "Poppins",
            fontSize: "25px",
            fontWeight: "500",
            color: "#FBE5C6",
            position:"absolute",
            top:"10%",
            left:"17%"
            }}>Please Enter Your Plot Size
        </Box>
        <Box
        sx={{
            height: "10px",
            display:"flex",
            fontFamily: "Poppins",
            fontSize: "18px",
            fontWeight: "500",
            color: "#D3D3D3",
            position:"absolute",
            top:"22%",
            left:"27%",

            }}>(default values are 0)
        </Box>
        <Box
        sx={{
            display: "flex",
            flexDirection:"row",
            alignItems: "center",
            borderRadius: "8px",
            padding: "6px 12px",
            gap: "5px",
            justifyContent:"center"
        }}
        >
                      
        <Box
        sx={{
            display: "flex",
            alignItems: "center",
            height: "70px",
            backgroundColor: "#FBE5C6",
            borderRadius: "8px",
            padding: "6px 12px",
        }}
        >
        <TextField
            label={`Width (${unit === "feet" ? "ft" : "m"})`}
            variant="outlined"
            size="small"
            value={plotWidth}
            onChange={handleWidthChange}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                dispatch(setClickedFalse());
              }
            }}
            sx={{
            marginRight: ".25rem",
            backgroundColor: "#FBE5C6",
            borderRadius: "8px",
            }}
        />
        </Box>
        
        
        <Box
        sx={{
            display: "flex",
            alignItems: "center",
            height: "70px",
            backgroundColor: "#FBE5C6",
            borderRadius: "8px",
            padding: "6px 12px",
        }}
        >
        <TextField
            label={`Length (${unit === "feet" ? "ft" : "m"})`}
            variant="outlined"
            size="small"
            value={plotHeight}
            onChange={handleHeightChange}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                dispatch(setClickedFalse());
              }
            }}
            sx={{
            backgroundColor: "#FBE5C6",
            borderRadius: "8px",
          
            }}
        />
        </Box>
        </Box>
        <Box
        sx={{
            position:"absolute",
            top: "70%",
            left:"15%",
            display: "flex",
            flexDirection:"row",
            gap: "5px",
        }}><DimensionsToggle/>
        
        <Button
        sx={{
            width:"175px",
            background:"#FF9A56",
            height: "50px",
            padding: "5px",
            borderRadius: "8px",
            border: "1px solid #E0E0E0",
            textAlign:"center",
            fontSize: "16px",
            font:"Poppins",
            fontWeight: "700",
            color:"#FBE5C6",
        }}
        
        onClick={()=>{
            dispatch(setClickedFalse());
        }}>Enter
        </Button></Box>
        
        
        </Box>
        
 
       
      
  );
};


export default PlotSizePopUp;
